export const getPaymentOptions = (isSelfPayer: boolean) => {
	if (isSelfPayer) {
		return [{ label: 'terms.suklUhrada.pacient', value: 'PACIENT' }];
	}
	return [
		{ label: 'terms.suklUhrada.zakladni', value: 'ZAKLADNI' },
		{ label: 'terms.suklUhrada.pacient', value: 'PACIENT' },
		{ label: 'terms.suklUhrada.zvysena', value: 'ZVYSENA' },
	];
};
